module.exports = __webpack_public_path__ + "public/img/logo_icon.07755aed.png";